import { css } from '@emotion/react';
import React from 'react';

import { HorizontalLogoDeck } from '~src/commons/components/logo-deck-row/horizontal-logo-deck';
import { useTranslations } from '~src/commons/utils/translations/translate';
import { fontStyles } from '~src/theme/fontStyles';

import { useGlobalState } from '../global-state';

export const CategoryManagerPlaceholder: React.FC = () => {
  const globalState = useGlobalState();
  // TODO: move to marketplace config
  const session = globalState.sessions[0];
  const { flags } = session;

  const { tICU } = useTranslations();

  const addressPlaceholder =
    flags.show_street_on_address_module || flags.show_city_on_address_module
      ? tICU('widget.SHIPPING_CATEGORIES_FULL_ADDRESS_PLACEHOLDER')
      : tICU('widget.SHIPPING_CATEGORIES_POSTAL_CODE_PLACEHOLDER');

  return (
    <div>
      {flags.show_carrier_logos_in_shipping_categories_placeholder && session.carrier_logos && (
        <div css={styles.logoSection}>
          <HorizontalLogoDeck carrierLogos={session.carrier_logos} />
        </div>
      )}
      <div css={styles.textSection}>{addressPlaceholder}</div>
    </div>
  );
};

const styles = {
  logoSection: {
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'center',
  },
  textSection: css({
    width: 'auto',
    ...fontStyles.px14_20,
    textAlign: 'center',
    margin: '12px',
  }),
};
